import React, { useContext, useEffect, useMemo } from 'react'
import { connect } from 'react-redux'
import Group from 'components/utils/Group'
import LineUserIcon from 'LuxKit/Icons/line/LineUserIcon'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import OfferFilterSelectBox from 'components/OfferPage/Filters/OfferFilterSelectBox'
import noop from 'lib/function/noop'
import OfferPageStateContext from 'contexts/OfferPage/offerPageStateContext'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import { generateRoomOccupants } from 'lib/offer/occupancyUtils'

interface MappedStateProps {
  businessAccount?: App.BusinessTraveller.CurrentBusinessAccount
}

interface Props {
  className?: string
}

function BusinessTravellerSelectHotelsOfferPageDesktopDisabled(props: Props & MappedStateProps) {
  const {
    className,
    businessAccount,
  } = props

  // Ensure rooms are set in OfferPage context for the traveller role (1 traveller = 1 room).
  const { rooms } = useContext(OfferPageStateContext)
  const offerPageDispatch = useOfferPageDispatch()
  useEffect(() => {
    if (!rooms) {
      offerPageDispatch({ type: OfferPageActions.setRooms, rooms: [generateRoomOccupants()] })
    }
  }, [rooms, offerPageDispatch])

  const travellerValue = useMemo(() => {
    if (!businessAccount?.employee) {
      return undefined
    }
    const { firstName = '', lastName = '' } = businessAccount.employee
    const name = `${firstName} ${lastName}`.trim()
    return name ? <b>{name}</b> : undefined
  }, [businessAccount?.employee])

  return (
    <Group className={className} direction="horizontal" gap={8}>
      <OfferFilterSelectBox
        data-testid="multi-room-travellers-select"
        icon={<LineUserIcon />}
        label="Travellers"
        placeholder="Select travellers"
        value={travellerValue}
        disabled
        onClick={noop}
      />
      <OfferFilterSelectBox
        data-testid="multi-room-rooms-select"
        icon={<LineBedIcon />}
        label="Rooms"
        placeholder="Select rooms"
        value={<b>1 room</b>}
        disabled
        onClick={noop}
      />
    </Group>
  )
}

export default connect<MappedStateProps, {}, Props, App.State>((state) => {
  return {
    businessAccount: state.businessTraveller.currentBusinessAccount,
  }
})(BusinessTravellerSelectHotelsOfferPageDesktopDisabled)
